import { makeStyles, Theme } from "@material-ui/core/styles";

import { LoginBgUser } from "../../assets/images";

const buttonPadding = 15;

const modalVerticalPadding = 65;

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    position: "relative",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    padding: 0,
    overflow: "hidden",
    width: "100%",
    height: "100vh",
    backgroundImage: `url(${LoginBgUser})`,
    backgroundPosition: "center",
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    backgroundClip: "border-box",
  },

  modalWebCam: {
    position: "relative",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "space-between",
    padding: 20,
    paddingBottom: 50,
    backgroundColor: theme.palette.background.paper,
    borderRadius: 18,
    maxWidth: 500,
    width: "100%",
    "& span": {
      fontSize: 18,
      fontWeight: "normal",
      width: 150,
      textAlign: "center",
    },
  },

  formView: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
  },

  title: {
    fontSize: 34,
    fontWeight: "bold",
    marginBottom: 12,
  },

  accessOptions: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    marginTop: 28,
  },

  accessOptionsTitle: {
    fontSize: 20,
    fontWeight: 400,
    lineHeight: 1.25,
    marginBottom: 22,
    color: "#333333",
  },

  accessOptionsList: {
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "center",
    gap: 22,
  },

  accessOption: {
    width: 90,
    minHeight: 96,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: 0,
    border: 0,
    backgroundColor: "transparent",
    cursor: "pointer",
    font: "inherit",

    "& img": {
      width: 68,
      height: 68,
      flexShrink: 0,
    },

    "& span": {
      width: "100%",
      marginTop: 10,
      fontSize: 12,
      fontWeight: 400,
      lineHeight: 1.15,
      textAlign: "center",
      color: "#333333",
    },
  },

  keyboard: {
    display: "grid",
    gridTemplateColumns: "repeat(3, 1fr)",
    gridGap: "28px 24px",
    width: 215,
    height: 305,
    marginTop: 65,
    marginLeft: 38,
  },

  keyboardPassword: {
    display: "grid",
    gridTemplateColumns: "repeat(2, 1fr)",
    gridGap: "28px 24px",
    width: 234,
    height: 224,
    marginTop: 80,
    marginLeft: 38,
  },

  buttonPassword: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: 108,
    height: 56,
    padding: buttonPadding,
    borderRadius: 16,
    backgroundColor: "#E6E6E6",

    "& span": {
      fontSize: 18,
      fontWeight: "bold",
    },
  },

  button: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: 56,
    height: 56,
    padding: buttonPadding,
    borderRadius: 16,
    backgroundColor: "#E6E6E6",

    "& span": {
      fontSize: 18,
      fontWeight: "bold",
    },
  },

  buttonZero: {
    width: "auto",
    gridColumn: "1 / 3",
  },

  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },

  modalView: {
    position: "relative",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "space-between",
    width: 345,
    height: 445,
    backgroundColor: theme.palette.background.paper,
    borderRadius: 18,
    paddingTop: modalVerticalPadding,
    paddingBottom: modalVerticalPadding,

    "& span": {
      fontSize: 18,
      fontWeight: "normal",
      width: 150,
      textAlign: "center",
    },
  },

  close: {
    position: "absolute",
    top: 15,
    right: 15,
    width: 24,
    height: 24,
    borderWidth: 1,
    borderColor: 'black'
  },
  closeFace: {
    top: 15,
    right: 15,
    width: 24,
    height: 24,
    borderWidth: 1,
    borderColor: 'black',
    marginLeft: 'auto',
  },

  adminActions: {
    position: "fixed",
    right: 0,
    bottom: 0,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "space-around",
    height: 130,
  },

  action: {
    width: 42,
    height: 42,
  },

  entityName: {
    position: "fixed",
    left: 12,
    bottom: 12,
    fontSize: 12,
    lineHeight: 1.2,
    color: "#333333",
  },

  errorHelper: {
    color: theme.palette.error.main,
    marginBottom: 12,
  },
}));

export default useStyles;
